import Vue from "vue"
import App from "./App.vue"
import { Globel } from "./globel"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import { initHttp } from "./utils/http"
import router from "./router"

const http = initHttp()


// 挂载到Vue原型
Vue.prototype.$http = http

window.$http = http

Vue.use(ElementUI)

Vue.config.productionTip = false

let globel = Vue.observable(new Globel())
Vue.prototype.$globel = globel
window.$global = globel

window.$eventBus = new Vue()

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app")
